// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.default-message[data-v-7589fa01] {\n  position: absolute;\n  top: -25px;\n  right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
